const ro = {
  avisoLegal: "Ciornă orientativă generată din datele înregistrate în NuvliPro. Nu înlocuiește consultanța profesională. Verific-o cu contabilul tău înainte de a o depune.",
  lockPago: "Exporturile pentru contabil sunt o funcție plătită.",
  imp: { IVA: "TVA", IGIC: "IGIC", IPSI: "IPSI" },
  ter: { comun: "Teritoriu comun", canarias: "Insulele Canare", ceuta_melilla: "Ceuta și Melilla", foral_pv: "Țara Bascilor", foral_navarra: "Navarra" },
  tipo: { autonomo: "Persoană fizică autorizată", sociedad: "Societate" },
  q: { 1: "T1 · ian–mar", 2: "T2 · apr–iun", 3: "T3 · iul–sep", 4: "T4 · oct–dec" },
  periodoT: "T{{n}} {{year}}",
  periodoP: "Plata {{n}} {{year}}",
  sub: "{{imp}} și impozit pe venit pe trimestru și rezumat anual",
  pie: "Sumele se calculează automat din facturile emise și cheltuielile înregistrate în fiecare trimestru.",
  regimen: {
    proTitulo: "Planul Pro:",
    proTexto: "regim fiscal automat pe teritoriu (TVA, IGIC și Haciendas Forales), Formularul 420 în Insulele Canare, Formularul 202 pentru societăți, Formularul 111, memento-uri pentru termene și verificarea calității datelor.",
    pasarPro: "Treci la Pro",
    modelo: " (formularul {{m}})",
    pagos: "plăți anticipate: formularul {{m}}",
    corregido: "Corectat manual · schimbă",
    detectado: "Detectat automat · corectează",
    faltan: "Îți lipsesc datele fiscale ({{que}}): am presupus teritoriu comun și persoană fizică autorizată până le completezi.",
    cp: "codul poștal", nif: "NIF/CIF", y: " și ",
    foral: "Domiciliul tău fiscal este în {{nombre}}: TVA-ul și plățile anticipate se depun la {{hacienda}}, cu formulare și termene forale proprii. Această ciornă îți servește drept ghid; declarația o pregătește contabilul tău.",
    ipsi: "În Ceuta și Melilla se aplică IPSI în loc de TVA. NuvliPro nu îl calculează încă: cere-i contabilului să pregătească declarația.",
  },
  card: {
    baseVentas: "Bază vânzări", baseGastos: "Bază cheltuieli", rep: "{{imp}} colectată", sop: "{{imp}} deductibilă",
    irpf: "Reținere impozit (IRPF)", horas: "Ore lucrate", bases: "Baze pe cotă de {{imp}}", base: "{{imp}} {{pct}}% · bază",
    resultado: "Rezultat {{imp}} ({{estado}})", aIngresar: "de plată", aCompensar: "de compensat",
    igicCanarias: "IGIC · lucrări în Insulele Canare", ivaFuera: "TVA · lucrări în afara Insulelor Canare",
    ipsiRep: "IPSI colectat", ipsiAviso: "IPSI necalculat: îl pregătește contabilul tău.",
    isp: "Taxare inversă · separat", ispEmitidas: "Emise (bază, fără taxă)", ispRecibidas: "Primite (bază)",
    ispCuota: "Taxă autolichidată (se declară și se deduce)",
  },
  btn: {
    docGestoria: "Doc. contabil", docAnual: "Doc. contabil (anual)", enviar: "Trimite", m: "F.{{m}}", modelo: "Formularul {{m}}",
    m420Pro: "Formularul 420: Planul Pro", excel: "Excel", ver130: "Vezi 130",
  },
  anual: { titulo: "Rezumat anual {{year}}", ipsi: "IPSI colectat (necalculat)", resultado: "Rezultat {{imp}} anual" },
  doc: { gestoria: "Document pentru contabil", modelo: "Formularul {{m}}" },
  toast: {
    generado: "{{doc}} generat", trimestre: " (T{{n}})", anual: " (anual {{year}})", error: "Nu s-a putut genera: {{doc}}",
    excelOk: "Raportul {{year}} exportat pentru contabil (XLSX)", excelError: "Raportul nu a putut fi exportat",
    m130Error: "Formularul 130 nu a putut fi calculat", reduccionError: "Reducerea nu a putut fi salvată",
  },
  m130: {
    titulo: "Formularul 130 — Impozit pe venit", acum: "(cumulat T{{n}})", anual: "(anual {{year}})",
    desc: "Plata anticipată cumulată a anului, minus reținerile și sumele plătite în trimestrele anterioare.",
    ingresos: "Venituri impozabile (cumulat)", gastos: "Cheltuieli deductibile (cumulat)", rendimiento: "Venit net",
    reduccion: "Reducere {{pct}} % cheltuieli greu de justificat", pago: "Plată anticipată ({{pct}} %)",
    retenciones: "Rețineri suportate", anteriores: "Plăți din trimestrele anterioare",
    aIngresar: "Rezultat de plată", negativo: "Rezultat negativ (de plată: 0 €)",
    marcar: "Aplică reducerea de {{pct}} % pentru cheltuieli greu de justificat (max. {{max}}/an). Verifică cu contabilul tău.",
    cerrar: "Închide", pdf: "Descarcă PDF",
  },
  m202: {
    titulo: "Formularul 202 — plăți anticipate {{year}} (estimare)",
    desc: "Impozit pe profit: {{pct}} % din profitul cumulat al anului. Contabilul tău poate folosi altă metodă.",
    plazo: "Plata {{p}} · se depune între 1 și 20 {{mes}}", mes: { 1: "aprilie", 2: "octombrie", 3: "decembrie" },
    tramo: { 3: "ian–mar", 9: "ian–sep", 11: "ian–nov" }, beneficio: "Profit cumulat ({{tramo}})",
    cuota: "{{pct}} % din profit", menos: "Rețineri și plăți anterioare", estimacion: "Estimare de plată",
  },
  m111: {
    titulo: "Formularul 111 — rețineri {{year}}",
    desc: "Rețineri din salarii (le introduci tu) și de la profesioniștii pe care îi plătești cu reținere (din cheltuielile tale).",
    nominas: "Rețineri din salarii (manual)", profesionales: "Profesioniști: {{n}} beneficiar(i), bază {{base}}",
    total: "Total de plată", guardado: "Reținerile din salarii pentru T{{n}} au fost salvate",
    errorGuardar: "Suma nu a putut fi salvată", invalido: "Introdu o sumă validă, de exemplu 1.234,56",
  },
  enviar: {
    titulo: "Trimite T{{n}} {{year}} contabilului tău",
    desc: "Va primi un e-mail cu aceste PDF-uri atașate. Dacă răspunde, e-mailul va ajunge la tine.",
    email: "E-mailul contabilului", placeholder: "contabil@exemplu.ro", boton: "Trimite", ok: "T{{n}} {{year}} trimis la {{email}} ({{docs}} PDF)",
    error: "Verifică e-mailul contabilului",
  },
  avisos: {
    plazos: "Termene apropiate", sinPlazos: "Nu există termene apropiate.",
    forales: "Termene forale: formularele se depun la Hacienda Foral și le pregătește contabilul tău.",
    modelos: "Formularele {{m}}", rango: "{{periodo}}: de la {{desde}} până la {{hasta}}",
    hoy: "Se termină azi", unDia: "A mai rămas 1 zi", dias: "Au mai rămas {{n}} zile",
    recordatorio: "Te anunțăm prin notificare și e-mail cu 10 zile înainte de sfârșitul fiecărui termen.",
    calidad: "Calitatea datelor {{year}}", ok: "Totul este în regulă: nu lipsesc date din facturile tale de anul acesta.",
    revisar: "Verifică", exenta: "Marchează ca scutită", exentaOk: "Cheltuială marcată ca scutită", exentaError: "Cheltuiala nu a putut fi marcată",
  },
  calidad: {
    facturas_nif: "Facturi emise fără NIF-ul clientului sau cu NIF incorect",
    facturas_cp_obra: "Facturi de lucrare fără codul poștal al lucrării (adaugă-l în fișa lucrării)",
    gastos_sin_impuesto: "Facturi primite fără taxa defalcată (TVA sau IGIC la 0)",
    gastos_nif: "Facturi primite fără NIF-ul furnizorului sau cu NIF incorect",
  },
  ajustes: {
    titulo: "Regim fiscal (Raport trimestrial)", det1: "Detectat automat:", det2: "după codul tău poștal și",
    det3: "după NIF/CIF-ul tău. Schimbă-l doar dacă nu este corect.",
    nota: "Această modificare afectează doar Raportul trimestrial. Facturile noi propun în continuare taxa după codul tău poștal și al clientului.",
    territorio: "Teritoriu fiscal", tipo: "Tip de contribuabil", automatico: "Automat ({{x}})",
    autonomo130: "Persoană fizică autorizată (formularul 130)", sociedad202: "Societate (formularul 202)",
    bloqueado: "Regimul automat face parte din Planul Pro.", guardado: "Regim fiscal salvat", error: "Nu s-a putut salva",
  },
};

export default ro;
